export default __webpack_public_path__ + "static/media/pizza1.bfdacf35.jpg";